module.exports = __webpack_public_path__ + "img/40_69_009_290.7a495808.jpg";